module.exports = __webpack_public_path__ + "img/1.b781c0f6.png";